"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORT_FILE_DATE_FORMAT = exports.YEAR_IN_MILLISECONDS = exports.MONTH_IN_MILLISECONDS = exports.WEEK_IN_MILLISECONDS = exports.DAY_IN_MILLISECONDS = exports.HOUR_IN_MILLISECONDS = exports.MINUTE_IN_MILLISECONDS = exports.YEAR_IN_SECONDS = exports.MONTH_IN_SECONDS = exports.WEEK_IN_SECONDS = exports.DAY_IN_SECONDS = exports.HOUR_IN_SECONDS = exports.MINUTE_IN_SECONDS = exports.YEAR_IN_MINUTES = exports.MONTH_IN_MINUTES = exports.WEEK_IN_MINUTES = exports.DAY_IN_MINUTES = exports.HOUR_IN_MINUTES = exports.YEAR_IN_HOURS = exports.MONTH_IN_HOURS = exports.WEEK_IN_HOURS = exports.DAY_IN_HOURS = void 0;
exports.DAY_IN_HOURS = 24;
exports.WEEK_IN_HOURS = exports.DAY_IN_HOURS * 7;
exports.MONTH_IN_HOURS = exports.DAY_IN_HOURS * 30;
exports.YEAR_IN_HOURS = exports.DAY_IN_HOURS * 365;
exports.HOUR_IN_MINUTES = 60;
exports.DAY_IN_MINUTES = 1440;
exports.WEEK_IN_MINUTES = 10080;
exports.MONTH_IN_MINUTES = 43200;
exports.YEAR_IN_MINUTES = 525600;
exports.MINUTE_IN_SECONDS = 60;
exports.HOUR_IN_SECONDS = 3600;
exports.DAY_IN_SECONDS = 86400;
exports.WEEK_IN_SECONDS = 604800;
exports.MONTH_IN_SECONDS = 2592000;
exports.YEAR_IN_SECONDS = 31536000;
exports.MINUTE_IN_MILLISECONDS = 60000;
exports.HOUR_IN_MILLISECONDS = 3600000;
exports.DAY_IN_MILLISECONDS = 86400000;
exports.WEEK_IN_MILLISECONDS = 604800000;
exports.MONTH_IN_MILLISECONDS = 2592000000;
exports.YEAR_IN_MILLISECONDS = 31536000000;
exports.EXPORT_FILE_DATE_FORMAT = "Do[_]MMM[_]YYYY";
